import { combineReducers } from 'redux';

const initialState = {
  myID: ""
}

function myID(state = initialState['myID'], actions) {
  switch (actions.type) {
    case 'SET':
      return state.myID
    default:
      return state
  }
}

const reducers = combineReducers({
  myID
})

export default reducers
